export default __webpack_public_path__ + "static/media/perplexity.c9b80769.svg";